import React from 'react'
import { IconWrapper } from '../IconWrapper'
import type { IconWrapperProps } from '../IconWrapper'

export const EcommThreeBulletLinesHorizontalIcon = React.forwardRef<
  SVGSVGElement,
  IconWrapperProps
>((props, forwardedRef) => {
  return (
    <IconWrapper {...props}>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        ref={forwardedRef}
      >
        <path
          d="M5.25 5C5.25 4.58579 5.58579 4.25 6 4.25L22 4.25C22.4142 4.25 22.75 4.58579 22.75 5 22.75 5.41422 22.4142 5.75 22 5.75L6 5.75C5.58579 5.75 5.25 5.41421 5.25 5zM5.25 12C5.25 11.5858 5.58579 11.25 6 11.25L22 11.25C22.4142 11.25 22.75 11.5858 22.75 12 22.75 12.4142 22.4142 12.75 22 12.75L6 12.75C5.58579 12.75 5.25 12.4142 5.25 12zM5.25 19C5.25 18.5858 5.58579 18.25 6 18.25L22 18.25C22.4142 18.25 22.75 18.5858 22.75 19 22.75 19.4142 22.4142 19.75 22 19.75L6 19.75C5.58579 19.75 5.25 19.4142 5.25 19z"
          fill="#222"
          fillRule="evenodd"
          clipRule="evenodd"
        />
        <path
          d="M4 5C4 5.55228 3.55229 6 3 6 2.44772 6 2 5.55228 2 5 2 4.44772 2.44772 4 3 4 3.55229 4 4 4.44772 4 5zM4 12C4 12.5523 3.55228 13 3 13 2.44772 13 2 12.5523 2 12 2 11.4477 2.44772 11 3 11 3.55228 11 4 11.4477 4 12zM4 19C4 19.5523 3.55228 20 3 20 2.44772 20 2 19.5523 2 19 2 18.4477 2.44772 18 3 18 3.55228 18 4 18.4477 4 19z"
          fill="#222"
        />
      </svg>
    </IconWrapper>
  )
})
